import GameList from '../../game/list/GameList.vue';

/** Раздел "Моё оборудование" */
export default {
  name: 'Sales',
  components: { GameList },
  props: ['type'],
  data() {
    return {
      /** Покупка/монтаж оборудования */
      saleType: 'installation',
      headers: [
        { text: 'Номер счёта', value: 'number' },
        { text: 'Дата создания', value: 'created_at' },
        { text: 'Дата обновления', value: 'created_at' }, // TODO
        { text: 'Бонусы', value: 'bonuses' },
        { text: 'Статус', value: 'status' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ],
      dateInstallation1: null,
      dateInstallation2: null,
      activePicker1: null,
      activePicker2: null,
      menu1: false,
      menu2: false,
    };
  },
  computed: {
    tableData() {
      return this.saleType === 'installation'
        ? this.salesTypical
        : this.salesTicket;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    salesTypical() {
      return this.$store.state.sales.salesTypical;
    },
    salesTicket() {
      return this.$store.state.sales.salesTicket;
    },
    computedDateFormatted1() {
      return this.FormatDate(this.dateInstallation1);
    },
    computedDateFormatted2() {
      return this.FormatDate(this.dateInstallation2);
    },
  },
  mounted() {
    this.saleType = this.type !== undefined ? this.type : 'installation';
    this.onChangeTab(this.saleType);
    this.$store.dispatch('SetTitle', 'Отчёты о монтаже и покупке оборудования');
    this.$store.dispatch('sales/GetActions', {
      profile_id: this.$store.state.user.profile_id,
    });

    this.$store.dispatch('sales/GetSales', {
      profile_id: this.$store.state.user.profile_id,
    });
  },
  methods: {
    showUpdateCard(item) {
      // Форму и акцию берём из самого монтажа/покупки:
      // actions.typical/ticket - лишь последняя актуальная акция
      const isInstallation = this.saleType === 'installation';
      const action = item.action ?? (isInstallation ? this.actions.typical : this.actions.ticket);
      const table = Boolean(action.show_products_in_table);
      this.$router.push(
        `/${isInstallation ? 'sale' : 'sale-fns'}/${table ? 'table/' : ''}${action.id}/${item.id}`,
      );
    },
    getDisplayValue(bonuses) {
      if (bonuses === null || bonuses === undefined) {
        return '';
      }
      return bonuses.toLocaleString('ru');
    },
    /** Записать дату */
    SaveDate1(date) {
      this.$refs.menu1.save(date);
    },
    SaveDate2(date) {
      this.$refs.menu2.save(date);
    },
    /** Форматировать дату */
    FormatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo':
          return 'color-orange';
        case 'draft':
          return 'color-grey';
        case 'declined':
          return 'color-red';
        case 'paid':
          return 'color-green';
        case 'approved':
          return 'color-green';
        case 'verified':
          return 'color-green';
        case 'new':
          return 'color-blue';
        case 'adminReview':
          return 'color-light-blue';
        default:
          return '';
      }
    },
    onChangeTab(tab) {
      this.$router.push(`/sales/${tab}`).catch();
    },
  },
};
